module.exports = __webpack_public_path__ + "img/Illustration.796c5964.png";